class PlayMetricsModel {
  constructor (data) {
      const {
        allPlayMetrics,
        scoringPlays,
        homeRuns,
        hardHits,
        strikeouts,
        leadChange,
        highLeverage,
        winProb,
        keyMoments
      } = data;
      this.allPlayMetrics = allPlayMetrics;
      this.scoringPlays = scoringPlays;
      this.homeRuns = homeRuns;
      this.hardHits = hardHits;
      this.strikeouts = strikeouts;
      this.leadChange = leadChange;
      this.highLeverage = highLeverage;
      this.winProb = winProb;
      this.keyMoments = keyMoments;
  }
}

export default PlayMetricsModel;
